import { defineStore } from 'pinia'

import type { AuthModel } from '@develop/ia-api-library'
import type { PolicyTypeModel, PolicyVersionsModel } from '@/models/agb'

export const useAgbStore = defineStore('agb', () => {
  const tempAuthData = ref<AuthModel>()

  const requiredPolicyVersion = reactive<PolicyVersionsModel>({
    agb: null, // terms of use
    datenschutz: null, // privacy policy
  })

  const hasPoliciesToAccept = computed(() => Object.values(requiredPolicyVersion).some(Boolean))

  const tempTokens = computed(() => ({ token: tempAuthData.value?.token, refreshToken: tempAuthData.value?.refreshToken }))

  const setPolicyVersion = (type: PolicyTypeModel, version: number | null) => {
    requiredPolicyVersion[type] = version
  }

  const setPolicyVersions = ({ agb, datenschutz }: PolicyVersionsModel) => {
    setPolicyVersion('agb', agb ?? null)
    setPolicyVersion('datenschutz', datenschutz ?? null)
  }

  const resetRequiredPolicies = () => {
    const entries = (Object.keys(requiredPolicyVersion) as PolicyTypeModel[])
    entries.forEach((key) => {
      requiredPolicyVersion[key] = null
    })
  }

  const saveTempAuthData = (data: AuthModel) => {
    set(tempAuthData, data)
  }

  const clearTempAuthData = () => {
    set(tempAuthData, undefined)
  }

  return {
    tempTokens,
    hasPoliciesToAccept,
    requiredPolicyVersion,
    tempAuthData,
    setPolicyVersions,
    resetRequiredPolicies,
    saveTempAuthData,
    clearTempAuthData,
  }
})
